import { AbstractControl, ValidationErrors } from '@angular/forms';

export class SpaceValidator {
  static cannotContainSpace(control: AbstractControl): ValidationErrors | null {
    if (String(control?.value)?.indexOf(' ') >= 0) {
      return { cannotContainSpace: true };
    }

    return null;
  }

  static cannotContainStartingSpace(
    control: AbstractControl
  ): ValidationErrors | null {
    if (String(control?.value)?.startsWith(' ')) {
      return { cannotContainStartingSpace: true };
    }

    return null;
  }
  static cannotContainEndingSpace(
    control: AbstractControl
  ): ValidationErrors | null {
    if (String(control?.value)?.endsWith(' ')) {
      return { cannotContainEndingSpace: true };
    }

    return null;
  }
}
